import { render, staticRenderFns } from "./purchaseRequestInfoModal.vue?vue&type=template&id=5c467770&scoped=true&"
import script from "./purchaseRequestInfoModal.vue?vue&type=script&lang=js&"
export * from "./purchaseRequestInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRequestInfoModal.vue?vue&type=style&index=0&id=5c467770&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c467770",
  null
  
)

export default component.exports